import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { InquiryComponent } from './inquiry.component';

@NgModule({
  declarations: [InquiryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [SharedModule, PipesModule],
  exports: [InquiryComponent],
})
export class InquiryModule {}
